import BaseModal from "./BaseModal";

/**
 * This class represents modals, that fire when their initialization is called.
 */
export default class NotificationModal extends BaseModal {

  constructor(modalSelector) {
      super();

      this.modalSelector = modalSelector;
  }

  /**
   * This function initialize the modal.
   */
  initModal() {
    if(this.modalExists(this.modalSelector))
      $(this.modalSelector).modal({});
  }

  /**
   * This function will return true if the modal (from modal selector) has set data attribute modal-fire to 1.
   *
   * @returns {boolean}
   */
  canFire() {
    return parseInt($(this.modalSelector).data('modal-fire')) == 1;
  }
}
